import LOGO_MARUICHI from '../assets/img/logo/partner_15.webp'
import LOGO_SUNSCO from '../assets/img/logo/partner_15.png'
import LOGO_PIZZA4P from '../assets/img/logo/partner_16.png'
import LOGO_KAO from '../assets/img/logo/partner_17.png'
import LOGO_KEWPIE from '../assets/img/logo/partner_18.png'
import LOGO_ORO from '../assets/img/logo/partner_19.png'
import LOGO_SHIFTASIA from '../assets/img/logo/partner_20.png'

export const listTestimonialFixture = [
  {
    id: 1,
    logo: LOGO_SUNSCO,
    name: 'Maruichi Sun Steel JSC',
    department: 'Manufacturing',
    content:
      '“freeC is a reliable partner in labor supply, providing quality candidates and enthusiastic support in recruiting for Maruichi Sun Steel.”'
  },
  {
    id: 2,
    logo: LOGO_PIZZA4P,
    name: 'Pizza 4Ps ',
    department: 'Food & Beverage',
    content:
      '“In my brief experience with freeC, they have been fast, supportive, attentive, friendly, and made valuable recommendations without pressure.”'
  },
  {
    id: 3,
    logo: LOGO_KAO,
    name: 'KAO',
    department: 'Cosmetics Manufacturing',
    content: `“Thanks to freeC for their excellent support in recruitment, including quality candidates, diverse sources, quick adaptability, and great customer service.`
  },
  {
    id: 4,
    logo: LOGO_KEWPIE,
    name: `Kewpie`,
    department: 'Food Manufacturing',
    content: `“I am highly satisfied with the recruitment consultants at freeC. They promptly send CVs that mostly meet our company's requirements. ”`
  },
  {
    id: 5,
    logo: LOGO_ORO,
    name: `oRo`,
    department: 'IT Services',
    content: `“We ask recruiting service for engineers and designers to freeC. Not only they recommend us very quick due our HR to connect candidates. And freeC create the best path for both companies and candidate.”`
  },
  {
    id: 4,
    logo: LOGO_SHIFTASIA,
    name: `Shift Asia`,
    department: 'Software',
    content: `“freeC is highly proactive and responsive in supporting candidates for Shift Asia, and the quality of candidates meets the requirements of Shift Asia.”`
  }
]
